// extracted by mini-css-extract-plugin
export default {"wrapperInner":"Assignment_wrapperInner__335Qi","root":"Assignment_root__fIyFZ","collapseContainer":"Assignment_collapseContainer__3iu8A"};